import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";


import {load} from "../constructionCalculationsNoteSlice";
import type {RootState} from "../../../store";
import useCalculationNewHook from "../../../hooks/useCalculationNewHook";

/**
 * Hook used to load foundation results data for the construction calculations note
 */
const useLoadFoundationResults = (): void => {
  const dispatch = useDispatch();
  const {getCalculationNoteFoundationResultsById} = useCalculationNewHook();
  const {selectedCalculationResults} = useSelector(
    (state: RootState) => state.constructionCalculationsNew,
  );

  useEffect(() => {
    void (async () => {
      if (selectedCalculationResults !== undefined) {
        const result = await getCalculationNoteFoundationResultsById(
          selectedCalculationResults.calculationId,
        );
        dispatch(load(result?.data ?? undefined));
      }
    })();
  }, [dispatch, getCalculationNoteFoundationResultsById, selectedCalculationResults]);
};

export default useLoadFoundationResults;
